export const environment = {
  production: false,
  maintenanceMode: false,
  userBackend: 'https://lassedesk.top/al/user',
  filesBackend: 'https://lassedesk.top/al/files',
  tutorsBackend: 'https://lassedesk.top/al/tutors',
  coursesBackend: 'https://lassedesk.top/al/files',
  chatWidgetUrl: 'https://chat.alphabees.de/development/chat-widget.js',
  courseGenerationUrl: 'https://canvas.lassedesk.top',
  // Creator › „Kurs von Hand bauen“ needs the course editor (AlphaCourse app); on only where it runs
  creatorCourseEditor: true,

  analyticsBotId: '0801e9b0-000a-4948-968b-319dca86dce4',
  analyticsApiKey: '18d61a7d-6d8f-4b83-9b57-ce1db205a2e0',
};
